<template>
  <div class="app-checkout-selection" :class="[this.process]">
    <h1><slot name="txtHeadline">MNP Toggle Button</slot></h1>
    <form>
      <div class="mnp-data--info card">
        <div class="heading">
          <h2 class="h5">
            <slot name="txtInfoCardTitleActive"></slot>
          </h2>
        </div>
        <p>
          <slot name="txtInfoCardDescActive"></slot>
        </p>
      </div>
      <div class="mnp-data--provider">
        <provider-select  :process="process"
                          ref="providerSelect"
                          :key="1"
                          :withNetworkSelect="false"
                          :active.sync="active"
                          :brandName.sync="provider.brandName"
                          :network.sync="provider.network"
                          :providerKey.sync="provider.key"
                          :providerCode.sync="provider.code"
                          :providerNetwork.sync="provider.network"
                          :relatedTariff.sync="provider.relatedTariff"
                          :unportableFound.sync="provider.unportable"
                          :invalid.sync="invalid.provider"
                          :preselectProvider="preselectProvider"
                          :quick-selection-brand="quickSelectionBrands"
                          @mnpin-provider-determined="storeSelectedProvider"
                          @clearErrorToast="clearActiveToasts"
                          frontend-context="checkout">
          <template v-for="slot in possibleChildSlotsFor('ProviderSelect')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </provider-select>
      </div>
      <div class="mnp-data--porting-data" v-if="getProviderListLoadingStatus === 'LOADED'">
        <porting-data
          ref="portingData"
          :key="1"
          :portingDataMsisdn.sync="portingData.msisdn"
          :portingDataDateType.sync="portingData.dateType"
          :portingDataConfirmation.sync="portingData.confirmation"
          :portingDataConfirmationOptIn.sync="portingData.confirmationOptIn"
        >
          <template v-for="slot in possibleChildSlotsFor('PortingData')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </porting-data>
        <SimonModal
          :is-visible="showPortingDataConfirmOptInInfoModal"
          id="porting-data-confirm-opt-in-info-modal"
          @hide="hideModalConfirmOptIn"
          :btnCancelTitle="getSlotText('btnCancelConfirmOptIn')"
        >
          <template v-slot:modalTitle>
            <h3><slot name="txtTitleConfirmOptIn"></slot></h3>
          </template>
          <slot name="txtInfoConfirmOptIn"></slot>
        </SimonModal>
      </div>
      <SimSelection :sim-type.sync="simType">
        <template v-for="slot in possibleChildSlotsFor('SimData')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </SimSelection>
      <ContractHolder :process="process">
        <template v-for="slot in possibleChildSlotsFor('Holder')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ContractHolder>
    </form>
    <Stepper
      @next="openModalConfirmOptIn()"
      @prev="back()"
      :show-prev="true"
      :aria-label-prev="getSlotText('accessibilitySelfservicePrevBtnAltStepper')"
      :aria-label-next="getSlotText('accessibilitySelfserviceNextBtnAltStepper')"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
      <template slot="btnNext">
        <slot v-if="getProviderListLoadingStatus === 'LOADED'" name="btnNextMnpStepper"></slot>
        <slot v-else name="btnNextStepper"></slot>
      </template>
    </Stepper>
  </div>
</template>
<script>
import preFilledObjectInput from '@/mixins/preFilledObjectInput'
import preFilledInput from '@/mixins/preFilledInput'
import isValid from '@/mixins/validators/isValid'
import validationFlow from '@/mixins/validators/validationFlow'
import Stepper from '@/components/generic/Stepper.vue'
import PortingData from '@/components/checkout/mnpData/PortingData.vue'
import ProviderSelect from '@/components/checkout/mnpData/ProviderSelect.vue'
import trackingHandler from '@/mixins/trackingHandler'
import SimSelection from '@/components/checkout/belatedPorting/SimSelection.vue'
import ContractHolder from '@/components/checkout/belatedPorting/ContractHolder.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'Selection',
  data () {
    return {
      showPortingDataConfirmOptInInfoModal: false,
      invalid: {
        provider: true
      },
      active: true,
      preselectProvider: ''
    }
  },
  props: {
    process: {
      type: String,
      default: 'ordering'
    }
  },
  async created () {
    await this.getProviderList()
  },
  mixins: [
    isValid,
    preFilledObjectInput('provider', 'getProvider'),
    preFilledObjectInput('portingData', 'getPortingData'),
    preFilledInput('simType', 'getSimType'),
    validationFlow,
    trackingHandler
  ],
  components: {
    SimonModal,
    ContractHolder,
    SimSelection,
    ProviderSelect,
    PortingData,
    Stepper
  },
  methods: {
    setPortingData (portingData) {
      this.$store.commit(`checkoutv2/${this.process}/_mnpData/setPortingData`, portingData)
    },
    setProvider (provider) {
      this.$store.commit(`checkoutv2/${this.process}/_mnpData/setProvider`, provider)
    },
    setSimType (simType) {
      this.$store.commit(`checkoutv2/${this.process}/_simData/setSimType`, simType)
    },
    getProviderList () {
      this.$store.dispatch(`checkoutv2/${this.process}/_mnpData/getProviderList`)
    },
    storeSelectedProvider () {
      this.setProvider(this.provider)
      this.$emit('updatedProvider')
    },
    openModalConfirmOptIn () {
      // Ensure live feedback for validation errors
      if (this.$refs.portingData) {
        this.$refs.portingData.forceValidationOnNestedInputs()
      }
      if (this.$refs.providerSelect) {
        this.$refs.providerSelect.vflowForceFeedback()
      }
      // Check if form validation was successful
      if (!this.invalid.provider && !this.$refs.portingData.isFormInvalid) {
        if (this.portingData.confirmationOptIn === 'false') {
          this.showPortingDataConfirmOptInInfoModal = true
        } else {
          this.save()
        }
      } else {
        this.vFlowScrollToFirstElemment()
        this.vFlowGetFirstErrorElementName().then((result) => {
          this.triggerValidationErrorTracking(result)
        })
      }
    },
    hideModalConfirmOptIn () {
      this.showPortingDataConfirmOptInInfoModal = false
      this.save()
    },
    back () {
      window.location.href = this.getSlotText('linkBackButtonHolder')
    },
    findAndSetFocusManually () {
      const targetStepName = this.getCurrentStepName
      const targetStepLi = document.querySelector(`li.${targetStepName}`)

      if (targetStepLi) {
        // Find the button
        const targetButton = targetStepLi.querySelector("[role='button']")

        if (targetButton) {
          targetButton.setAttribute('tabindex', '0') // make it focusable
          targetButton.focus()
        }
      }
    },
    save () {
      if (this.simType) {
        this.setSimType(this.simType)
      }

      // Check if form validation was successful
      if (!this.invalid.provider && !this.$refs.portingData.isFormInvalid) {
        this.setPortingData(this.portingData)
        this.startLoader()

        this.$store
          .dispatch('checkoutv2/' + this.process + '/initiate')
          .then(() => {
            this.clearActiveToasts()
            this.$emit('goForward')
          })
          .catch((error) => {
            this.errorToast(this.getErrorMessage(error))
            this.triggerErrorTracking(error)
          })
          .finally(() => {
            this.stopLoader(() => {
              this.findAndSetFocusManually()
            })
          })
      } else {
        this.vFlowScrollToFirstElemment()
        this.vFlowGetFirstErrorElementName().then((result) => {
          this.triggerValidationErrorTracking(result)
        })
      }
    },
    clearActiveToasts () {
      this.clearToasts()
    }
  },
  computed: {
    getActive () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/active`] === true
    },
    getProvider () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/provider`]
    },
    getPortingData () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/portingData`]
    },
    getProviderListLoadingStatus () {
      return this.$store.getters[`checkoutv2/${this.process}/_mnpData/providerListLoadingStatus`]
    },
    getSimType () {
      return this.$store.getters[`checkoutv2/${this.process}/_simData/simType`]
    },
    quickSelectionBrands () {
      return this.getSlotText('txtBrand1CommonProviderSelect') + ',' + this.getSlotText('txtBrand2CommonProviderSelect') + ',' + this.getSlotText('txtBrand3CommonProviderSelect') + ',' + this.getSlotText('txtBrand4CommonProviderSelect') + ',' + this.getSlotText('txtBrand5CommonProviderSelect')
    },
    getCurrentStepName: function () {
      return this.$store.getters['checkoutv2/' + this.process + '/step']
    }
  }
}
</script>
